import React from 'react';
import '../components/Loader.css';
import { useLoader } from '../context/LoaderContext';

export default function Loader() {
  const { visible, message } = useLoader();
  if (!visible) return null;

  return (
    <div className="global-loader-overlay" role="status" aria-live="polite">
      <div className="global-loader-box">
        <div className="global-loader-spinner" />
        <div className="global-loader-message">{message || 'Loading...'}</div>
      </div>
    </div>
  );
}
